import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Palette, Save } from 'lucide-react';

export default function AdminBrand() {
    const [b, setB] = useState(null);
    const [busy, setBusy] = useState(false);
    const [ok, setOk] = useState('');
    useEffect(() => { api.get('/brand-settings').then((r) => setB(r.data)); }, []);
    if (!b) return null;
    const save = async () => {
        setBusy(true); setOk('');
        try { await api.put('/brand-settings', b); setOk('Brand settings saved.'); }
        finally { setBusy(false); }
    };
    return (
        <div data-testid="admin-brand-page" className="max-w-3xl">
            <h1 className="font-display font-extrabold text-3xl text-slate-900 flex items-center gap-2"><Palette className="h-7 w-7 text-brand-blue" /> Brand Settings</h1>
            <p className="text-sm text-slate-500 mt-1 mb-5">Configure how the academy looks across the deployment.</p>
            <div className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
                <I label="Client name" v={b.client_name} on={(v) => setB({ ...b, client_name: v })} t="brand-client-name" />
                <I label="Academy name" v={b.academy_name} on={(v) => setB({ ...b, academy_name: v })} t="brand-academy-name" />
                <I label="Tagline" v={b.tagline} on={(v) => setB({ ...b, tagline: v })} t="brand-tagline" />
                <I label="Logo URL" v={b.logo_url} on={(v) => setB({ ...b, logo_url: v })} t="brand-logo-url" />
                <div className="grid grid-cols-3 gap-3">
                    <I label="Primary color" v={b.primary_color} on={(v) => setB({ ...b, primary_color: v })} t="brand-primary" />
                    <I label="Accent" v={b.accent_color} on={(v) => setB({ ...b, accent_color: v })} t="brand-accent" />
                    <I label="Secondary" v={b.secondary_accent} on={(v) => setB({ ...b, secondary_accent: v })} t="brand-secondary" />
                </div>
                <div className="flex gap-2 items-center pt-2">
                    {[b.primary_color, b.accent_color, b.secondary_accent].map((c, i) => (
                        <div key={i} className="h-10 w-10 rounded-xl border border-slate-200" style={{ background: c }} />
                    ))}
                </div>
                {ok && <div className="text-emerald-600 text-sm">{ok}</div>}
                <button onClick={save} disabled={busy} className="mt-2 inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-brand-blue text-white font-semibold disabled:opacity-60" data-testid="brand-save-btn">
                    <Save className="h-4 w-4" /> {busy ? 'Saving…' : 'Save settings'}
                </button>
            </div>
        </div>
    );
}

function I({ label, v, on, t }) {
    return <label className="block">
        <span className="text-xs font-semibold text-slate-700">{label}</span>
        <input value={v || ''} onChange={(e) => on(e.target.value)} className="mt-1 w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm" data-testid={t} />
    </label>;
}
